// extracted by mini-css-extract-plugin
export var avatarContainer = "_h1-0";
export var avatarTypingWave = "_h1-i";
export var gray = "_h1-f";
export var green = "_h1-c";
export var icon = "_h1-9";
export var image = "_h1-1";
export var lg = "_h1-6";
export var md = "_h1-5";
export var presenceDot = "_h1-b";
export var red = "_h1-d";
export var sm = "_h1-4";
export var status = "_h1-a";
export var typingDot = "_h1-h";
export var typingPill = "_h1-g";
export var xl = "_h1-7";
export var xs = "_h1-3";
export var xxl = "_h1-8";
export var xxs = "_h1-2";
export var yellow = "_h1-e";